import React from "react";
import { withTranslation } from "react-i18next";
import { urlFromEnum, jumpTypeEnum } from "@/utils/enum";
import { api } from "@/utils/api";
import url from "@/utils/url";
import ArticleItem from "@/react-components/ArticleItem";
import EmptyResult from "@/react-components/EmptyResult";
import NewsHeader from "@/react-components/NewsHeader";
import PickUp from "@/react-components/PickUp";
import LoadMore from "@/react-components/LoadMore";
import ShowNextPage from "@/react-components/ShowNextPage";
import ReactSlot from "@/react-components/ReactSlot";
import config from "@/utils/config";
import { Link as RouterLink } from "react-router-dom";
import AuthImage from "@/react-components/AuthImage";
import BannerCarousel from "@/react-components/BannerCarousel";

class HomeSection extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      articles: undefined,
      banners: [],
      rotationTime: 1000
    };

    this.reactSlotRef = React.createRef();
  }

  componentDidMount() {
    // this.reactSlotRef && this.reactSlotRef.current.dispatchEventDebounce();
    this.fetchData();
  }

  fetchData = () => {
    api.report
      .getList(null, {
        pageIndex: 1,
        pageSize: 6,
      })
      .then((response) => {
        this.setState({
          articles: response.list,
        });
      })
      .catch((error) => {
        console.error("error: " + error.message);
      });

    api.home
      .getbanners()
      .then((data) => {
        if (data) {
          const bannersData = data.banner.items.map(item => ({
            imgSrc: item.image,
            jumpType: item.jumpType,
            jumpLink: item.jumpLink,
            innerTabInnerUrlFlg:
              item.jumpType === jumpTypeEnum.InnerTab &&
              item.jumpLink.indexOf("http") !== 0,
          }));
          const rotationTimeData = data.banner.settings.rotationtime;

          this.setState({
            banners: bannersData,
            rotationTime: rotationTimeData
          });
        } else {
          this.setState({
            banners: null
          });
        }
      })
      .catch((error) => {
        console.error("error: " + error.message);
      });
  };

  /**
   * バナー表示用HTMLを作成します
   * @returns バナー表示用HTML
   */
  CreateBannersElement = (banners) => {
    return (
      <div className="banner-area">
        {banners.map((banner, index) => (
          <div className="banner-area-wrapper" tabIndex="0" key={index}>
            {banner.innerTabInnerUrlFlg ? (
              <RouterLink
                to={`${banner.jumpLink}${banner.jumpLink.indexOf("?") === -1 ? "?" : "&"
                  }from=${urlFromEnum.InnerTab}`}
              >
                <AuthImage
                  className="news-item-img"
                  src={banner.imgSrc}
                  isZoom={false}
                  alt=""
                />
              </RouterLink>
            ) : (
              <a
                href={banner.jumpLink}
                target={
                  banner.jumpType === jumpTypeEnum.NewBrowserTab ? "_blank" : ""
                }
                rel={
                  banner.jumpType === jumpTypeEnum.NewBrowserTab
                    ? "noopener noreferrer"
                    : ""
                }
              >
                <AuthImage
                  className="news-item-img"
                  src={banner.imgSrc}
                  isZoom={false}
                  alt=""
                />
              </a>
            )}
          </div>
        ))}
      </div>
    );
  };

  /**
 * カルーセル表示用HTMLを作成します
 * @returns カルーセル表示用HTML
 */
  CreateCarouselElement = (banners, rotationTime) => {
    const options = { loop: true }  // カルーセル動作オプション

    // カルーセル内に表示するバナーのHTML作成
    const slides = banners.map((banner, index) => (
      <div className="embla__slide" tabIndex="0" key={index}>
        {banner.innerTabInnerUrlFlg ? (
          <RouterLink
            to={`${banner.jumpLink}${banner.jumpLink.indexOf("?") === -1 ? "?" : "&"
              }from=${urlFromEnum.InnerTab}`}
          >
            <AuthImage
              className="news-item-img"
              src={banner.imgSrc}
              isZoom={false}
              alt=""
            />
          </RouterLink>
        ) : (
          <a
            href={banner.jumpLink}
            target={
              banner.jumpType === jumpTypeEnum.NewBrowserTab ? "_blank" : ""
            }
            rel={
              banner.jumpType === jumpTypeEnum.NewBrowserTab
                ? "noopener noreferrer"
                : ""
            }
          >
            <AuthImage
              className="news-item-img"
              src={banner.imgSrc}
              isZoom={false}
              alt=""
            />
          </a>
        )}
      </div>
    ));

    // カルーセルのHTMLを返却
    return (
      <BannerCarousel slides={slides} delay={rotationTime} options={options} />
    );
  }

  render() {
    const {
      articles,
      banners = this.state.banners,
      rotationTime = this.state.rotationTime
    } = this.state;
    //バナー、カルーセルHTML作成処理呼び出し
    let bannerElement = null;
    if (banners != null && banners.length <= 2) {
      bannerElement = this.CreateBannersElement(banners);
    } else if (banners != null) {
      bannerElement = this.CreateCarouselElement(banners, rotationTime);
    }

    return (
      <div className="main-content-area">
        <div className="home-main-content-area">
          <ReactSlot
            ref={this.reactSlotRef}
            key={this.props?.router?.location?.key}
            {...this.props}
          />
          {bannerElement}
          <NewsHeader showMore={false} />
          {articles && (
            <React.Fragment>
              {articles.length > 0 ? (
                <React.Fragment>
                  <div className="news-section-content">
                    {articles.map((item, index) => (
                      <ArticleItem key={index} articles={item} />
                    ))}
                  </div>
                  <LoadMore to={{ pathname: url.news }} />
                  <ShowNextPage to={{ pathname: url.news }} />
                </React.Fragment>
              ) : (
                <EmptyResult />
              )}
            </React.Fragment>
          )}
          <div id="react-slot-root-2"></div>
        </div>
        {config.pickUpDisplay && <PickUp />}
      </div>
    );
  }
}

export default withTranslation()(HomeSection);
